import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import Auth from './auth';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const language = useSelector((state) => state.language);
  
  return (
    // 로그인한 경우에만 접근 가능하고 안되어있으면 로그인 페이지로 이동
    <Route {...rest} render={props => Auth.isAuth() ? <Component {...props} /> : <Redirect to={`/signin`} /> } />
  );
};

export default PrivateRoute;
